import { render, staticRenderFns } from "./detailPage.vue?vue&type=template&id=f616098e&scoped=true"
import script from "./detailPage.vue?vue&type=script&lang=js"
export * from "./detailPage.vue?vue&type=script&lang=js"
import style0 from "./detailPage.vue?vue&type=style&index=0&id=f616098e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f616098e",
  null
  
)

export default component.exports